var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 8.33333C13.3327 6.49167 11.841 5 9.99935 5C8.15768 5 6.66602 6.49167 6.66602 8.33333C6.66602 10.175 8.15768 11.6667 9.99935 11.6667C11.841 11.6667 13.3327 10.175 13.3327 8.33333ZM8.33268 8.33333C8.33268 7.41667 9.08268 6.66667 9.99935 6.66667C10.916 6.66667 11.666 7.41667 11.666 8.33333C11.666 9.25 10.916 10 9.99935 10C9.08268 10 8.33268 9.25 8.33268 8.33333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5174 18.1749C9.65906 18.2749 9.83406 18.3332 10.0007 18.3332C10.1674 18.3332 10.3424 18.2832 10.4841 18.1749C10.7341 17.9915 16.6924 13.6999 16.6674 8.32487C16.6674 4.64987 13.6757 1.6582 10.0007 1.6582C6.32573 1.6582 3.33406 4.64987 3.33406 8.32487C3.30906 13.6915 9.2674 17.9915 9.5174 18.1749ZM10.0007 3.3332C12.7591 3.3332 15.0007 5.57487 15.0007 8.3332C15.0174 12.0332 11.3424 15.3582 10.0007 16.4499C8.65906 15.3582 4.98406 12.0415 5.00073 8.3332C5.00073 5.57487 7.2424 3.3332 10.0007 3.3332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location2.f9d80017c109582761a48e5f2a624b13.svg";
export { ForwardRef as ReactComponent };